/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { AmiDetailsTemplate } from 'src/app/@amiga-pyme/components/ami-details/ami-detail.template';

@Component({
  selector: 'pg-branch-store-details',
  template: `
    <p-fieldset [legend]="legend" [toggleable]="true">
      <ami-details
        [settings]="settings"
        (action)="onReciveAction($event)"
      ></ami-details>
    </p-fieldset>

    <pg-branch-store-select
      *ngIf="select.canBeDisplay"
      (selectedRowsEvent)="onSelected($event)"
    ></pg-branch-store-select>
  `
})
export class BranchStoreDetailsComponent extends AmiDetailsTemplate {
  @Input() legend = 'Sucursal';
  ngOnInit() {
    this.settings = {
      head: {
        title: '',
        subtitle: ''
      },
      body: {
        rows: [
          { header: 'Nombre', field: 'name' },
          { header: 'Dirección', field: 'address' },
          { header: 'Departamento', field: 'department' },
          { header: 'Provincia', field: 'province' },
          { header: 'Distrito', field: 'district' }
        ]
      }
    };
    this.addActionSelect();
  }
}

export class BranchStoreSelected {
  value: any;
  legend: any;
  constructor(legend = 'Sucursal') {
    this.value = null;
    this.legend = legend;
  }
  onSelect(row) {
    if (row) {
      this.value = row;
    }
  }

  onReset() {
    this.value = null;
  }

  getId() {
    return this.value?.id;
  }
}
